import IBimehMarkaziDto from '../../../../../../ShakhsSales/SakhsSalesBimehNameh/Commands/Soddor/IBimehMarkaziDto';

const BimehMarkaziInitialStateSodoor: IBimehMarkaziDto = {
  shomarehBimehNameh: '',
  shomarehMotor: '',
  shomarehShasi: '',
  codeYektaBimehMarkazi: '',
};

export default BimehMarkaziInitialStateSodoor;
